import { WorkPatternItemDto } from 'api/generated';
import { bankHolidays } from 'features/holidays/components/attendance-schedule-calendar/bank-holidays';
import _ from 'lodash';
import moment from 'moment';
import business from 'moment-business';

export function durationDays(
  start: string | Date | undefined,
  end: string | Date | undefined,
  pattern: WorkPatternItemDto[]
): number {
  if (!isValidDate(start) || !isValidDate(end)) {
    return 0;
  }

  const momentStart = moment(start);
  const momentEnd = moment(end);

  const countDays = momentEnd.add(1, 'day').diff(momentStart, 'days');

  let workingDays = 0;

  for (let i = 0; i < countDays; i++) {
    const currentDay = momentStart.add(i, 'day');
    const isWorkingDay = pattern.find((x) => x.dayOfWeek == currentDay.day())?.isEnable ?? false;

    if (isWorkingDay && business.isWeekDay(currentDay)) workingDays++;
  }

  const bh = bankHolidays.events.filter((item) => moment(item.date) >= momentStart && moment(item.date) <= momentEnd);

  return workingDays - bh.length;
}

export function isValidDate(date: string | Date | undefined) {
  if (!date) {
    return false;
  }

  const d = moment(date);
  const min = moment('1970-01-01');
  return d.isValid() && d.isAfter(min);
}

export type DayOfWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const DaysOfWeek = {
  numericOrder: _.range(0, 7) as DayOfWeek[],
  fromSunday: _.range(0, 7) as DayOfWeek[],
  fromMonday: [1, 2, 3, 4, 5, 6, 0] as DayOfWeek[]
};

export function getDayOfWeekName(dayOfWeek: number, short: boolean = false) {
  switch (dayOfWeek) {
    case 0:
      return short ? 'Su' : 'Sunday';
    case 1:
      return short ? 'Mo' : 'Monday';
    case 2:
      return short ? 'Tu' : 'Tuesday';
    case 3:
      return short ? 'We' : 'Wednesday';
    case 4:
      return short ? 'Th' : 'Thursday';
    case 5:
      return short ? 'Fr' : 'Friday';
    case 6:
      return short ? 'Sa' : 'Saturday';
  }
}

export function isWeekend(date: moment.Moment | Date): boolean {
  const d = moment(date);
  return d.isoWeekday() === 6 || d.isoWeekday() === 7;
}

export function splitDateTime(dateTimeValue: Date | null) {
  const dateTime = dateTimeValue ? moment(dateTimeValue) : undefined;
  const date = dateTime ? dateTime.clone().startOf('day') : undefined;
  const time = dateTime ? dateTime.diff(date, 'minutes') : undefined;

  return { date, time };
}
